import { PaginationSize } from "@/common/enum/pagination-size";
import { noticeService } from "@/services/notice-service";
import { BasePageDto } from "@/types/dto/base-page-dto";
import { initNoticePage, NoticeDetailDto } from "@/types/dto/notice-detail-dto";
import { useEffect, useState } from "react";
import { PartnerNoticeHeader } from "../header/PartnerNoticeHeader";
import { ParnerNoticeSimplePanel } from "./ParnerNoticeSimplePanel";

export const ParnerNoticePanel = () => {
  const [noticePage, setNoticePage] =
    useState<BasePageDto<NoticeDetailDto>>(initNoticePage);

  const getPage = async () => {
    try {
      const response = await noticeService.getPage({
        page: noticePage.currentPage,
        size: PaginationSize.SIZE_5,
      });
      if (response.ok) {
        setNoticePage(response.data);
      }
      console.log(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getPage();
  }, [noticePage.currentPage]);

  const goToPage = (pageNumber: number) => {
    setNoticePage((prevState) => ({
      ...prevState,
      currentPage: pageNumber,
    }));
  };

  return (
    <div className="flex flex-col">
      <PartnerNoticeHeader noticePage={noticePage} goToPage={goToPage} />
      <ParnerNoticeSimplePanel items={noticePage.contents} />
    </div>
  );
};
